/* Header dropdowns and the mobile menu — Polton All Stars.

   Everything goes through setOpen() so hover and click can never disagree
   about state.

   Below 990px there is a Menu button and the nav is a vertical panel; the
   parent toggles are the SAME buttons as on desktop and expand in place. The
   old behaviour — flattening everything into a horizontal scrolling strip —
   was rebuilt on 8 Sep 2026 after she reported it did not work on her phone. */
(function () {
  var nav = document.querySelector('[data-nav]');
  if (!nav) return;

  var parents = Array.prototype.slice.call(nav.querySelectorAll('.n-nav__item--parent'));
  if (!parents.length) return;

  var DESKTOP = '(min-width: 990px)';
  var hoverTimer = null;

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  function setOpen(li, open) {
    var btn = li.querySelector('[data-nav-toggle]');
    if (!btn) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    li.classList.toggle('is-open', open);
  }

  function closeAll(except) {
    parents.forEach(function (li) {
      if (li !== except) setOpen(li, false);
    });
  }

  parents.forEach(function (li) {
    var btn = li.querySelector('[data-nav-toggle]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeAll(li);
      setOpen(li, !open);
    });

    /* Hover is a desktop nicety only — on touch it would fight the tap. */
    li.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      closeAll(li);
      setOpen(li, true);
    });

    li.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { setOpen(li, false); }, 160);
    });

    /* Tabbing out of the group closes it. */
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) setOpen(li, false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = nav.querySelector('.n-nav__item--parent.is-open');
    if (!open) return;
    setOpen(open, false);
    var btn = open.querySelector('[data-nav-toggle]');
    if (btn) btn.focus();
  });

  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target)) closeAll(null);
  });

  /* ---------------------------------------------------------------------
     The mobile Menu button.
     --------------------------------------------------------------------- */
  var head = document.querySelector('.n-head');
  var menuBtn = document.querySelector('[data-menu-toggle]');

  if (head && menuBtn) {
    function setMenu(open) {
      head.classList.toggle('is-menu-open', open);
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) closeAll(null);
    }

    menuBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      setMenu(menuBtn.getAttribute('aria-expanded') !== 'true');
    });

    /* A tap anywhere outside the header closes it. */
    document.addEventListener('click', function (e) {
      if (!head.contains(e.target)) setMenu(false);
    });

    /* Escape closes the menu once no dropdown is left open, so one press
       closes the dropdown and a second closes the menu. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (nav.querySelector('.n-nav__item--parent.is-open')) return;
      if (head.classList.contains('is-menu-open')) {
        setMenu(false);
        menuBtn.focus();
      }
    });

    /* Following a link should not leave the menu open behind the new page,
       and on browsers that restore the page from cache it would. */
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });

    /* Widening past the breakpoint: drop the mobile state so the desktop nav
       is never left hidden by a stale class. */
    var desktopQuery = window.matchMedia(DESKTOP);
    function onBreakpoint() {
      if (desktopQuery.matches) setMenu(false);
    }
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onBreakpoint);
    else if (desktopQuery.addListener) desktopQuery.addListener(onBreakpoint);
  }
})();
